export default {
    orders: {
        actionUndo: {
            message: "Se você clicou por engano, clique no link abaixo para reverter.",
            undo: "Clique para desfazer"
        }
    }
}